import {
  React,
  Component,
} from 'imports/CommonImports';

import {IconWithTooltip} from 'imports/DesignImports';

import {
  TooltipIcon,
} from 'imports/IconsImports';

import {
  Paper,
  Divider,
  TextField,
  SelectField,
  MenuItem,
  Checkbox,
  RadioButton,
  RadioButtonGroup,
} from 'material-ui';

const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const styles = {
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    justifyContent: 'space-around'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1',
  },
  formContainer: {
    backgroundColor: '#FBFBFB',
    marginTop: '0.5em',
  },
  contentContainer: {
    padding: '1em'
  },
  section: {
    padding: '1em'
  },
  formData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  tooltipIcon: {
    color: '#212F55',
    marginLeft: '0.1em'
  },
  labelTooltipContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  labelSection: {
    flex: '1',
    padding: '1em',
    display: 'flex',
    justifyContent: 'space-around'
  },
  fourSection: {
    flex: '5',
    padding: '1em',
  },
  label: {
    textAlign: 'right',
    fontSize: '0.8em',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  textAreaLabel: {
    textAlign: 'right',
    flex: '1',
    marginTop: '1.5em',
    fontSize: '0.8em',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  divider: {
    marginRight: '5em'
  },
  textAreaContainer:{
    flex: '1'
  },
  textArea: {
    borderRight: '1px solid #E0E0E0',
    borderLeft: '1px solid #E0E0E0',
    borderTop: '1px solid #E0E0E0',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  textField: {
    color: '#212F55',
    fontFamily: 'Lato',
    marginTop: '0.1em',
    width: 'inherit'
  },
  selectField: {
    color: '#212F55',
    fontFamily: 'Lato'
  },
  selectedMenuItem:{
    color: '#EC2024'
  },
  optionContainer:{
    flex: 4,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontStyle: 'italic',
    marginTop: '2em'
  },
  option: {
    display: 'table-cell',
    flex: 1,
    width: '25%'
  },
  fakeOption: {
    display: 'table-cell',
    visibility: 'hidden',
    flex: 1,
    width: '25%'
  }
}

class PostulationForm extends Component {
  constructor(props){
    super(props);
    if(props.project){
      this.state = {
        economicImpact: props.project.information.economic_impact,
        solutionType: props.project.options.filter((selection) => {return selection.filter_id === 1}).map((selection) => {return selection.option.name}),
        solutionSuggestions: ["Productos o servicios", "Mecanismos o procesos", "Modelos de negocios", "Tecnologías"],
        benefitType: props.project.options.filter((selection) => {return selection.filter_id === 21}).map((selection) => {return selection.option.name}),
        benefitSuggestions: ["Reducción de costos", "Generación de ingresos"],
        novelty: props.project.options.filter((selection) => {return selection.filter_id === 11}).map((selection) => {return selection.option.name})[0],
        implementationDate: new Date(props.project.information.start_date),
        name: props.project.information.name,
        leaderFirstName: props.project.information.leader_first_name,
        leaderLastName: props.project.information.leader_last_name,
        leaderEmail: props.project.information.leader_email,
        problem: props.project.information.problem,
        solution: props.project.information.solution,
        benefits: props.project.information.benefits,
        objetives: props.project.information.objetives,
        characteristics: props.project.information.characteristics,
        sponsorFirstName: props.project.information.sponsor_first_name,
        sponsorLastName: props.project.information.sponsor_last_name,
        area: props.project.information.area.name,
        yearSelection: (new Date(props.project.information.start_date)).getFullYear(),
        monthSelection: (new Date(props.project.information.start_date)).getMonth(),
        currentYear: (new Date()).getFullYear()
      }
    }
    else {
      this.state = {
        economicImpact: 1,
        solutionType: [],
        solutionSuggestions: ["Productos o servicios", "Mecanismos o procesos", "Modelos de negocios", "Tecnologías"],
        benefitType: [],
        benefitSuggestions: ["Reducción de costos", "Generación de ingresos"],
        novelty: "Nuevo para la empresa",
        implementationDate: null,
        name: '',
        leaderFirstName: '',
        leaderLastName: '',
        leaderEmail: '',
        problem: '',
        solution: '',
        benefits: '',
        objetives: '',
        characteristics: '',
        sponsorFirstName: '',
        sponsorLastName: '',
        area: '',
        yearSelection: null,
        monthSelection: null,
        currentYear: (new Date()).getFullYear()
      }
    }
  }

  render() {
    return (
      <Paper zDepth={1} style={{...styles.column, ...styles.formContainer}}>
        <div style={{...styles.row, ...styles.contentContainer}}>
          <div style={styles.row}>
            <div style={{...styles.column, ...styles.labelSection}}>
              <div style={styles.label}>Nombre del proyecto</div>
              <div style={styles.label}>Nombre líder</div>
              <div style={styles.label}>Apellidos líder</div>
              <div style={styles.label}>Mail líder</div>
            </div>
            <div style={{...styles.column, ...styles.section}}>
              <div style={styles.textFieldContainer}>
                <TextField
                  style={styles.textField}
                  name="Name"
                  value={this.state.name}
                  onChange={(event) => this.handleTextChange(event, "name")}
                  />
              </div>
              <div style={styles.textFieldContainer}>
                <TextField
                  style={styles.textField}
                  name="Leader First Name"
                  value={this.state.leaderFirstName}
                  onChange={(event) => this.handleTextChange(event, "leaderFirstName")}
                  />
              </div>
              <div style={styles.textFieldContainer}>
                <TextField
                  style={styles.textField}
                  name="Leader Last Name"
                  value={this.state.leaderLastName}
                  onChange={(event) => this.handleTextChange(event, "leaderLastName")}
                  />
              </div>
              <div style={styles.textFieldContainer}>
                <TextField
                  style={styles.textField}
                  name="Leader Email"
                  errorText={this.state.emailError}
                  value={this.state.leaderEmail}
                  onChange={(event) => this.handleTextChange(event, "leaderEmail")}
                  />
              </div>
            </div>
          </div>
          <div style={styles.row}>
            <div style={{...styles.column, ...styles.labelSection}}>
              <div style={styles.label}>Sponsor</div>
              <div style={styles.label}>Área</div>
              <div style={styles.label}>Fecha de implementación <IconWithTooltip icon={<TooltipIcon style={styles.tooltipIcon}/>} tooltip="En qué año y mes se comenzó o comenzará a ejecutar el proyecto"/></div>
              <div style={styles.label}>Impacto económico ({this.props.data ? this.props.data.company.currency : this.props.company_currency})<IconWithTooltip icon={<TooltipIcon style={styles.tooltipIcon}/>} tooltip="Escribe un valor aproximado a modo de referencia"/></div>
            </div>
            <div style={{...styles.column, ...styles.section}}>
              <div>
                <TextField
                  style={styles.textField}
                  name="Sponsor"
                  disabled={true}
                  value={this.props.data ? this.props.data.manager.first_name + ' ' + this.props.data.manager.last_name : this.state.sponsorFirstName + ' ' + this.state.sponsorLastName}
                  onChange={(event) => this.handleTextChange(event, "sponsor")}
                  />
              </div>
              <div>
                <TextField
                  style={styles.textField}
                  name="Area"
                  disabled={true}
                  value={this.props.data ? this.props.data.area.name : this.state.area}
                  onChange={(event) => this.handleTextChange(event, "area")}
                  />
              </div>
              <div>
                <SelectField value={this.state.monthSelection} onChange={this.handleMonthChange} maxHeight={200} floatingLabelText="Mes de implementación">
                  <MenuItem value={null} primaryText="" />
                  <MenuItem value={0} primaryText="Enero" />
                  <MenuItem value={1} primaryText="Febrero" />
                  <MenuItem value={2} primaryText="Marzo" />
                  <MenuItem value={3} primaryText="Abril" />
                  <MenuItem value={4} primaryText="Mayo" />
                  <MenuItem value={5} primaryText="Junio" />
                  <MenuItem value={6} primaryText="Julio" />
                  <MenuItem value={7} primaryText="Agosto" />
                  <MenuItem value={8} primaryText="Septiembre" />
                  <MenuItem value={9} primaryText="Octubre" />
                  <MenuItem value={10} primaryText="Noviembre" />
                  <MenuItem value={11} primaryText="Diciembre" />
                </SelectField>
                <SelectField value={this.state.yearSelection} onChange={this.handleYearChange} maxHeight={200} floatingLabelText="Año de implementación">
                  <MenuItem value={null} primaryText="" />
                  <MenuItem value={this.state.currentYear-10} primaryText={(this.state.currentYear-10).toString()} />
                  <MenuItem value={this.state.currentYear-9} primaryText={(this.state.currentYear-9).toString()} />
                  <MenuItem value={this.state.currentYear-8} primaryText={(this.state.currentYear-8).toString()} />
                  <MenuItem value={this.state.currentYear-7} primaryText={(this.state.currentYear-7).toString()} />
                  <MenuItem value={this.state.currentYear-6} primaryText={(this.state.currentYear-6).toString()} />
                  <MenuItem value={this.state.currentYear-5} primaryText={(this.state.currentYear-5).toString()} />
                  <MenuItem value={this.state.currentYear-4} primaryText={(this.state.currentYear-4).toString()} />
                  <MenuItem value={this.state.currentYear-3} primaryText={(this.state.currentYear-3).toString()} />
                  <MenuItem value={this.state.currentYear-2} primaryText={(this.state.currentYear-2).toString()} />
                  <MenuItem value={this.state.currentYear-1} primaryText={(this.state.currentYear-1).toString()} />
                  <MenuItem value={this.state.currentYear} primaryText={this.state.currentYear.toString()} />
                  <MenuItem value={this.state.currentYear+1} primaryText={(this.state.currentYear+1).toString()} />
                  <MenuItem value={this.state.currentYear+2} primaryText={(this.state.currentYear+2).toString()} />
                  <MenuItem value={this.state.currentYear+3} primaryText={(this.state.currentYear+3).toString()} />
                  <MenuItem value={this.state.currentYear+4} primaryText={(this.state.currentYear+4).toString()} />
                  <MenuItem value={this.state.currentYear+5} primaryText={(this.state.currentYear+5).toString()} />
                  <MenuItem value={this.state.currentYear+6} primaryText={(this.state.currentYear+6).toString()} />
                  <MenuItem value={this.state.currentYear+7} primaryText={(this.state.currentYear+7).toString()} />
                  <MenuItem value={this.state.currentYear+8} primaryText={(this.state.currentYear+8).toString()} />
                  <MenuItem value={this.state.currentYear+9} primaryText={(this.state.currentYear+9).toString()} />
                  <MenuItem value={this.state.currentYear+10} primaryText={(this.state.currentYear+10).toString()} />
                </SelectField>
            </div>
            </div>
          </div>
        </div>
        <Divider inset={true} style={styles.divider}/>
        <div style={{...styles.row, ...styles.contentContainer}}>
            <div style={{...styles.column, ...styles.labelSection}}>
              <div style={styles.textAreaLabel}>Problema<br/><br/><i>Describa la necesidad problema u oportunidad que da origen al proyecto.</i></div>
              <div style={styles.textAreaLabel}>Solución<br/><br/><i>Explique en que consiste la solución: objetivos, principales características y atributos.</i></div>
              <div style={styles.textAreaLabel}>Beneficios <br/><br/><i>Describa todos los beneficios que genera el proyecto: económico, sociales, ambientales, entre otros.</i></div>
            </div>
            <div style={{...styles.column, ...styles.fourSection}}>
              <div>
                <TextField
                  name="Problem"
                  textareaStyle={styles.textArea}
                  multiLine={true}
                  rows={4}
                  rowsMax={4}
                  fullWidth={true}
                  value={this.state.problem}
                  onChange={(event) => this.handleTextChange(event, "problem")}
                  />
              </div>
              <div>
                <TextField
                  name="Solution"
                  textareaStyle={styles.textArea}
                  multiLine={true}
                  rows={4}
                  rowsMax={4}
                  fullWidth={true}
                  value={this.state.solution}
                  onChange={(event) => this.handleTextChange(event, "solution")}
                  />
              </div>
              <div>
                <TextField
                  name="Benefits"
                  textareaStyle={styles.textArea}
                  multiLine={true}
                  rows={4}
                  rowsMax={4}
                  fullWidth={true}
                  value={this.state.benefits}
                  onChange={(event) => this.handleTextChange(event, "benefits")}
                  />
              </div>
            </div>
        </div>
        <Divider inset={true} style={styles.divider}/>
        <div style={{...styles.row, ...styles.contentContainer}}>
          <div style={{...styles.column, ...styles.labelSection}}>
            <div style={styles.label}>Tipo de solución</div>
            <div style={styles.label}>Grado de novedad</div>
            <div style={styles.label}>Tipo de beneficio</div>
          </div>
          <div style={{...styles.column, ...styles.fourSection}}>
            <div style={styles.optionContainer}>
              {Array.from(new Array(4), (x, j) => {
                if(this.state.solutionSuggestions.length > j){
                  return(
                    <Checkbox
                    style={styles.option}
                    key={j}
                    label={this.state.solutionSuggestions[j]}
                    onCheck={() => this.handleCheckboxChange('solutionType', this.state.solutionSuggestions[j])}
                    checked={this.state.solutionType.includes(this.state.solutionSuggestions[j])}
                    />
                  );
                }
                return (
                  <Checkbox
                  style={styles.fakeOption}
                  key={j}
                  label="Fake checkbox"
                  />
                )
                })
              }
            </div>
            <div>
              <RadioButtonGroup style={styles.optionContainer} name="Grado de novedad" defaultSelected={this.state.novelty} onChange={this.handleSelectChange}>

                <RadioButton
                  style={styles.option}
                  label={"Nuevo para la empresa"}
                  value={"Nuevo para la empresa"}
                />
                <RadioButton
                  style={styles.option}
                  label={"Nuevo en la industria del país"}
                  value={"Nuevo en la industria del país"}
                />
                <RadioButton
                  style={styles.option}
                  label={"Nuevo en la industria a nivel global"}
                  value={"Nuevo en la industria a nivel global"}
                />
                <RadioButton
                  style={styles.fakeOption}
                />

              </RadioButtonGroup>

            </div>
            <div style={styles.optionContainer}>
              {Array.from(new Array(4), (x, j) => {
                if(this.state.benefitSuggestions.length > j){
                  return(
                    <Checkbox
                    style={styles.option}
                    key={j}
                    label={this.state.benefitSuggestions[j]}
                    onCheck={() => this.handleCheckboxChange('benefitType', this.state.benefitSuggestions[j])}
                    checked={this.state.benefitType.includes(this.state.benefitSuggestions[j])}
                    />
                  );
                }
                return (
                  <Checkbox
                  style={styles.fakeOption}
                  key={j}
                  label="Fake checkbox"
                  />
                )
                })
              }
            </div>
          </div>
        </div>
      </Paper>
    );
  }

  handleSelectChange = (event, value) => {
    if(this.props.handleSelectChange)
      this.props.handleSelectChange(event, value);
    this.setState({novelty: value})
  }

  handleDateChange = (event, date) => {
    if(this.props.handleDateChange)
      this.props.handleDateChange(event, date)
    this.setState({implementationDate: date})
  }

  handleYearChange = (event, index, value) => {
    this.setState({
      yearSelection: value,
      implementationDate: value !== null && this.state.monthSelection !== null ? new Date(value, this.state.monthSelection, 1, 0, 0, 0, 0) : null
    }, ()=>{this.props.handleDateChange(event, this.state.implementationDate);});

  };

  handleMonthChange = (event, index, value) => {
    this.setState({
      monthSelection: value,
      implementationDate: this.state.yearSelection !== null && value !== null ? new Date(this.state.yearSelection, value, 1, 0, 0, 0, 0) : null
    }, ()=>{this.props.handleDateChange(event, this.state.implementationDate);});

  };

  handleTextChange = (event, type) => {
    if(this.props.handleTextChange)
      this.props.handleTextChange(event, type)
    this.setState({[type]: event.target.value})
    if(type === 'leaderEmail')
      !re.test(event.target.value.toLowerCase()) ? this.setState({emailError: 'Debes ingresar un email válido'}) : this.setState({emailError: ''})
    if(type === 'economicImpact')
      !parseInt(event.target.value, 10) ? this.setState({impactError: 'El impacto económico debe ser un número'}) : this.setState({impactError: ''})

  }

  handleCheckboxChange = (type, option) => {
    if(this.props.handleCheckboxChange)
      this.props.handleCheckboxChange(type, option);
    var index = this.state[type].indexOf(option);
    if(index === -1){
      this.setState({[type]: [...this.state[type], option]})
    }
    else {
      this.setState((prevState) => ({
        [type]: prevState[type].filter((_,i) => i !== index)
      }));
    }
  }
}

export default PostulationForm;



// WEBPACK FOOTER //
// ./src/components/postulation/PostulationForm.js